import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';

import ConfirmActionModal from './ConfirmActionModal';

const RuleDeleteConfirmModal = ({ onConfirm, onClose, rules, ...props }) => (
    <ConfirmActionModal
        onConfirm={onConfirm}
        onClose={onClose}
        title="Delete Rule(s)?"
        {...props}
    >
        Are you sure you want to delete these rule(s)?
        <ul>
            {rules.map(({ id, name }) => (
                <li key={id}>{name}</li>
            ))}
        </ul>
    </ConfirmActionModal>
);


RuleDeleteConfirmModal.defaultProps = {
    onClose:   () => {},
    onConfirm: () => {},
    rules:     []
};

RuleDeleteConfirmModal.propTypes = {
    onConfirm: func,
    onClose:   func,
    rules:     arrayOf(shape({
        name: string
    }))
};

export default RuleDeleteConfirmModal;
